export default __webpack_public_path__ + "static/media/icon-close-search.dbb6c82c.svg";